import { Component, OnInit } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { DevicesService } from 'src/app/_services/devices.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  diviceXs: boolean;
  diviceSm: boolean;
  time:Date = new Date(); 
  year:number; 

  constructor(public mediaObserver: MediaObserver, private devicesService: DevicesService) {
    this.year = this.time.getFullYear();
  }


  ngOnInit() {
    this.devicesService.dievice$.subscribe(res => {
      console.log("device",res)
      this.diviceXs = res === 'xs' ? true : false;
      this.diviceSm = res === 'sm' ? true : false;
    })
  }

}
